function generateDefaultCss(css: string) {
  return (
    `*,*:before,*:after{box-sizing:inherit}body,h1,h2,h3,h4,h5,h6,p,ol,ul{margin:0;padding:0;font-weight:normal}` +
    css.replaceAll(':root', ':host')
  );
}

export function appendElement(root: HTMLElement, component: HTMLElement, css: string) {
  let shadow;
  if ('CSSStyleSheet' in window && CSSStyleSheet.prototype.replaceSync) {
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(generateDefaultCss(css));
    shadow = root.attachShadow({ mode: 'open' });
    shadow.adoptedStyleSheets = [sheet];
  } else {
    const style = document.createElement('style');
    style.innerHTML = generateDefaultCss(css);

    shadow = root.attachShadow({ mode: 'open' });
    shadow.appendChild(style);
  }

  shadow.appendChild(component);
}
